export const OrderPageOptions: Record<string, any> = {
	All: 1,
	MissedOrder: 2
};
